import React from "react";
// Utils
import { constructSchemaData } from "utils/helpers/constructSchemaData";
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";
// Data
import homeSchemaData from "./schema.data.json";
import seoData from "./seo.data.json";
import homeContentData from "./data/homeContentData.json";
// Components
import DynamicHero from "components/DynamicHero";
import SchemaComponent from "components/CBSchema";
import { StyledMainPageContainer } from "index.styles";
import Testimonials from "../../components/Testimonials";
import SEO from "components/CBSEO";
import GetStartedToday from "pages/TherapyHub/components/GetStartedToday";
import FAQContent from "components/CBFAQ";
import StartYourJourney from "pages/TherapyHub/components/startYourJourney";
import ResourcesSlider from "pages/TherapyHub/components/resourcesSlider";
import CBDivider from "components/CBDivider";
import { ImageContainer } from "styles/components/imageContainer";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import TextBlock from "components/TextBlock";
import FourColumnSection from "styles/components/fourColumnSection";
import InsuranceSection from "components/InsuranceSection";

const componentMap = {
  "StartYourJourney": StartYourJourney,
  "ResourcesSlider": ResourcesSlider,
  "GetStartedToday": GetStartedToday,
  "Faq": FAQContent,
  "Divider": CBDivider,
  "ImageContainer": ImageContainer,
  "TwoColumnSection": TwoColumnSection,
  "TextBlock": TextBlock,
  "Testimonials": Testimonials,
  "FourColumnSection": FourColumnSection,
  "InsuranceSection": InsuranceSection,
  "DynamicHero": DynamicHero,
};
const spreadSchemaComponents = ["FourColumnSection", "TwoColumnSection", "InsuranceSection", "GetStartedToday", "TextBlock"];
const Home = () => {
  const schemaData = constructSchemaData(homeSchemaData.url, homeSchemaData.breadcrumbs);
  const renderedComponents = useDynamicPageRenderer(homeContentData, componentMap, spreadSchemaComponents);
  return (
    <StyledMainPageContainer id="home-page-container">
      <SchemaComponent schemas={schemaData} />
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      {renderedComponents}
    </StyledMainPageContainer>
  );
};

export default Home;
